<template>
    <div>
        <p-header title="我的優惠"/>
        <div class="select">
            <div class="item" :class="{selected: type === 'unused'}" @click="type = 'unused'">可使用</div>
            <div class="item" :class="{selected: type === 'used'}" @click="type = 'used'">使用紀錄</div>
            <div class="item" :class="{selected: type === 'expired'}" @click="type = 'expired'">已過期</div>
        </div>
        <component :is="type"></component>
    </div>
</template>

<script>
    import Header from './components/Header';
    import CouponUnused from "./components/coupon/CouponUnused";
    import CouponUsed from "./components/coupon/CouponUsed";
    import CouponExpired from "./components/coupon/CouponExpired";

    export default {
        name: 'Coupons',
        components: {
            'p-header': Header,
            'unused': CouponUnused,
            'used': CouponUsed,
            'expired': CouponExpired,
        },
        data() {
            return {
                type: 'unused'
            }
        }
    };
</script>

<style lang="scss" scoped>
    .select {
        padding: 15px;
        display: flex;

        .item {
            color: #000000;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            cursor: pointer;
            user-select: none;
            margin: 0 10px;
            padding: 0 5px;

            &.selected {
                color: #339933;
                position: relative;

                &:after {
                    position: absolute;
                    bottom: -4px;
                    left: 6px;
                    content: '';
                    background-color: #339933;
                    height: 3px;
                    width: 20px;
                    border-radius: 5px;
                }
            }
        }
    }
</style>
